import styled from 'styled-components/macro';

import { tokens } from '@olist/design-system-tokens';

import Icon from './Icon';

const LogoSvg = styled(Icon)`
  height: 32px;
  margin: ${tokens.spacing[1000]} 0 ${tokens.spacing[700]};
  width: 80px;
`;

export default LogoSvg;
